import { useState, useEffect } from 'react';

export interface NetworkStatus {
  isConnected: boolean;
}

/**
 * Tracks browser connectivity using the native online/offline events and
 * navigator.onLine.  Reliable for detecting full network drops; for
 * captive-portal / server-unreachable scenarios the Firestore offline
 * persistence layer handles caching.
 */
export function useNetworkStatus(): NetworkStatus {
  const [isConnected, setIsConnected] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsConnected(true);
    const handleOffline = () => setIsConnected(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isConnected };
}
